<template>
  <div class="px-5 pb-5">
    <div class="flex flex-col gap-5">
      <div
        class="flex flex-col sm:flex-row gap-5 justify between w-full items-end"
        v-for="(item, index) in filterData.slice()"
        v-bind:key="index"
      >
        <div class="w-full">
          <label
            class="font-primary font-normal text-base text-gray-400 pb-1 flex justify-between w-full"
          >
            {{ __("Skill") }}
            <div v-if="markMandatory == true">
              <Toggle
                v-model="item.mandatory"
                :value="item.mandatory"
                :setid="'mandatory'"
              />
            </div>
          </label>

          <Multiselect
            v-model="item.value"
            :values="skills"
            type="dynamic"
            :clearable="false"
            @query="getSkillsByQuery"
          />
        </div>
        <div
          class="p-2 bg-lightGray rounded-app w-12 text-center font-bold cursor-pointer"
          @click="removeItem(filterData, item)"
          v-if="index < filterData.length - 1"
        >
          <span>-</span>
        </div>
        <div
          class="p-2 bg-lightGray rounded-app w-12 text-center font-bold cursor-pointer"
          @click="pushItem(filterData)"
          v-if="index >= filterData.length - 1"
        >
          +
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import axios from "axios";
import { Toggle, Multiselect } from "../../global";
import { __ } from "../../../helpers";

const props = defineProps({
  markMandatory: Boolean,
  filterData: Array,
});

const skills = ref([]);

//combined the functions that were before into a function that searches while typing and returns the data in a readable form
const getSkillsByQuery = async (query) => {
  if (!query || query.length < 3) return;

  try {
    const res = await axios.get(route("skills.find_skills"), {
      params: { q: query },
    });

    const arr = Array.isArray(res.data.items)
        ? res.data.items
        : Array.isArray(res.data)
            ? res.data
            : [];

    skills.value = arr.map((item) => ({
      id: item.id,
      name: item.name,
    }));
  } catch (err) {
    console.error("Error fetching skills payload:", err, err.response?.data);
  }
};

function removeItem(idx) {
  props.filterData.splice(idx, 1);
}

function pushItem() {
  props.filterData.push({
    type: "string",
    value: {},
    mandatory: false,
  });
}
</script>
